import type { IconData } from '@stacksjs/iconify-core'

export const cn4x3: IconData = {
  "body": "<defs><path id=\"SVGMKMqY6jk\" fill=\"#ff0\" d=\"M-.6.8L0-1L.6.8L-1-.3h2z\"/></defs><path fill=\"#ee1c25\" d=\"M0 0h640v480H0z\"/><use width=\"30\" height=\"20\" href=\"#SVGMKMqY6jk\" transform=\"matrix(71.9991 0 0 72 120 120)\"/><use width=\"30\" height=\"20\" href=\"#SVGMKMqY6jk\" transform=\"matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)\"/><use width=\"30\" height=\"20\" href=\"#SVGMKMqY6jk\" transform=\"matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)\"/><use width=\"30\" height=\"20\" href=\"#SVGMKMqY6jk\" transform=\"matrix(6.5991 -23.0749 23.0746 6.59919 288 168)\"/><use width=\"30\" height=\"20\" href=\"#SVGMKMqY6jk\" transform=\"matrix(14.9991 -18.73557 18.73533 14.99929 240 216)\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default cn4x3
